import { render, staticRenderFns } from "./YsDaterangePicker.vue?vue&type=template&id=66684aef&scoped=true"
import script from "./YsDaterangePicker.vue?vue&type=script&lang=js"
export * from "./YsDaterangePicker.vue?vue&type=script&lang=js"
import style0 from "./YsDaterangePicker.vue?vue&type=style&index=0&id=66684aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66684aef",
  null
  
)

export default component.exports